import { configureStore } from "@reduxjs/toolkit";

// Slice
import userReducer from "./userSlice";

export default configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        immutableCheck: {
            warnAfter: 360
        },
        serializableCheck: {
            warnAfter: 360
        }
    }),
    reducer: {
        user: userReducer
    }
});